export function getStopLabel(index: number, total: number): string {
  if (index === 0) return 'Start'
  if (index === total - 1) return 'End'
  return `Intermediate`
}
